import { DishViewed } from "@dashboard/types";
import { type ReduxState } from "@dashboard/types/reduxState";

export type DishViewedReducerAction =
  | { type: "UPDATE_DISH_VIEWED"; payload: DishViewed }
  | { type: "FETCHED_DISH_VIEWED"; payload: DishViewed[] }
  | { type: "DELETE_DISH_VIEWED"; payload: string };

export const dishViewedReducer: (
  state: ReduxState["dishViewed"] | undefined,
  action: DishViewedReducerAction
) => ReduxState["dishViewed"] = (
  state: ReduxState["dishViewed"] = {
    initialDishViewedLoading: true,
    recentlyViewedDishes: [],
  },
  action: DishViewedReducerAction
) => {
  switch (action.type) {
    case "UPDATE_DISH_VIEWED":
      return {
        ...state,
        recentlyViewedDishes: [
          ...state.recentlyViewedDishes.filter(
            (dishViewed) => dishViewed.id !== action.payload.id
          ),
          action.payload,
        ],
      };

    case "FETCHED_DISH_VIEWED":
      return {
        ...state,
        initialLocationsLoading: false,
        recentlyViewedDishes: action.payload, // ordering is done in the action
      };

    case "DELETE_DISH_VIEWED":
      return {
        ...state,
        recentlyViewedDishes: state.recentlyViewedDishes.filter(
          (dishViewed) => dishViewed.id !== action.payload
        ),
      };
    default:
      return state;
  }
};
